import axios from "axios";
import {
  CLOSE_LOADER,
  LOADER_OPEN,
} from "../Component/store/dialogue/dialogue.type";
import store from "../Component/store/Provider";
import { baseURL, secretKey } from "./config";
import { validateSessionIntegrity } from "./permissionIntegrity";

export const openSpinner = () => {
  return store.dispatch({ type: LOADER_OPEN });
};

export const closeSpinner = () => {
  return store.dispatch({ type: CLOSE_LOADER });
};
function handleErrors(response) {

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response?.status}`);
  }
  return response.json();
}
export const apiInstance = axios.create({
  baseURL: baseURL,
});

apiInstance.interceptors.request.use(
  async (config) => {
    if (config.url && !config.url.includes("admin/login")) {
      const isValid = await validateSessionIntegrity();
      if (!isValid) {
        return Promise.reject(new Error("Session tampered"));
      }
    }

    openSpinner();

    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    config.headers.key = secretKey;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  (response) => {
    closeSpinner();
    return response;
  },
  (error) => {
    closeSpinner();
    return Promise.reject(error);
  }
);

export const apiInstanceFetch = {
  baseURL: `${baseURL}`, // Set your default base URL here
  headers: {
    "Content-Type": "application/json",
    key: `${secretKey}`,
  },
  get: async (url) => {
    if (!(await validateSessionIntegrity())) return Promise.reject(new Error("Session tampered"));
    openSpinner();
    return fetch(`${apiInstanceFetch?.baseURL}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        key: `${secretKey}`,
        Authorization: `${sessionStorage.getItem("token")}`, // dynamically fetch the token from sessionStorage
      },
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  post: async (url, data) => {
    if (!(await validateSessionIntegrity())) return Promise.reject(new Error("Session tampered"));
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        key: `${secretKey}`,
        Authorization: `${sessionStorage.getItem("token")}`, // dynamically fetch the token from sessionStorage
      },
      body: data,
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  patch: async (url, data) => {
    if (!(await validateSessionIntegrity())) return Promise.reject(new Error("Session tampered"));
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        key: `${secretKey}`,
        Authorization: `${sessionStorage.getItem("token")}`, // dynamically fetch the token from sessionStorage
      },
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  put: async (url, data) => {
    if (!(await validateSessionIntegrity())) return Promise.reject(new Error("Session tampered"));
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        key: `${secretKey}`,
        Authorization: `${sessionStorage.getItem("token")}`, // dynamically fetch the token from sessionStorage
      },
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  delete: async (url) => {
    if (!(await validateSessionIntegrity())) return Promise.reject(new Error("Session tampered"));
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        key: `${secretKey}`,
        Authorization: `${sessionStorage.getItem("token")}`, // dynamically fetch the token from sessionStorage
      },
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },
};
